













import { computed, defineComponent } from "@vue/composition-api";
import { INPUT_PROPS } from "@/const";
import DateTimeField from "@/components/InputDateTime/components/DateTimeField.vue";
import ValidationProvider from "@/components/ValidationProvider";

export default defineComponent({
  name: "InputDateTime",
  components: { DateTimeField, ValidationProvider },
  props: {
    ...INPUT_PROPS,
    min: { type: [Date, String] },
    max: { type: [Date, String] },
    dateFormat: { type: String, default: "MM/dd/yyyy" },
    timeFormat: { type: String, default: "hh:mm a" },
  },
  setup(props, { emit }) {
    const currentValue = computed({
      get() {
        return props.value;
      },
      set(v: string) {
        emit("input", v);
      },
    });

    const onValidation = (...v: any[]) => {
      emit("validation", ...v);
    };

    return { onValidation, currentValue };
  },
});
